import React from 'react';
import { Container, Typography, Box, Paper, List, ListItem, ListItemText } from '@mui/material';
import SEO from '../components/SEO';

const PrivacyPolicy = () => {
  return (
    <Container maxWidth="lg" sx={{ py: 8 }}>
      <SEO
        title="Privacy Policy - SOLID CLASSES"
        description="Read the privacy policy of SOLID CLASSES, detailing how we collect, use, protect, and handle your personal information and data."
        keywords="privacy policy, data privacy, SOLID CLASSES privacy, student data protection"
      />
      <Typography variant="h3" component="h1" gutterBottom align="center">
        Privacy Policy
      </Typography>
      <Typography variant="h6" color="text.secondary" paragraph align="center" sx={{ mb: 6 }}>
        Your privacy is critically important to us.
      </Typography>

      <Paper sx={{ p: { xs: 2, md: 4 } }}>
        <Typography variant="h5" component="h2" gutterBottom>
          1. Information We Collect
        </Typography>
        <Typography paragraph>
          We collect information to provide better services to all our users. The types of information we collect include:
        </Typography>
        <List dense>
          <ListItem>
            <ListItemText
              primary="Personal Information:"
              secondary="When you fill out our contact form, we collect personal information such as your name, email address, and phone number. This information is used solely to respond to your inquiries and provide you with relevant information about our courses and services."
            />
          </ListItem>
          <ListItem>
            <ListItemText
              primary="Usage Data:"
              secondary="We collect information on how the Service is accessed and used ('Usage Data'). This Usage Data may include information such as your computer's Internet Protocol address (e.g., IP address), browser type, browser version, the pages of our Service that you visit, the time and date of your visit, the time spent on those pages, unique device identifiers and other diagnostic data."
            />
          </ListItem>
          <ListItem>
            <ListItemText
              primary="Cookies and Tracking Technologies:"
              secondary="We use cookies and similar tracking technologies to track the activity on our Service and hold certain information. Cookies are files with a small amount of data which may include an anonymous unique identifier. You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent."
            />
          </ListItem>
        </List>

        <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 4 }}>
          2. How We Use Information
        </Typography>
        <Typography paragraph>
          SOLID CLASSES uses the collected data for various purposes:
        </Typography>
        <List dense>
          <ListItem>
            <ListItemText primary="To provide and maintain our Service."
            />
          </ListItem>
          <ListItem>
            <ListItemText primary="To notify you about changes to our Service."
            />
          </ListItem>
          <ListItem>
            <ListItemText primary="To allow you to participate in interactive features of our Service when you choose to do so."
            />
          </ListItem>
          <ListItem>
            <ListItemText primary="To provide customer support."
            />
          </ListItem>
          <ListItem>
            <ListItemText primary="To gather analysis or valuable information so that we can improve our Service."
            />
          </ListItem>
          <ListItem>
            <ListItemText primary="To monitor the usage of our Service."
            />
          </ListItem>
          <ListItem>
            <ListItemText primary="To detect, prevent and address technical issues."
            />
          </ListItem>
        </List>

        <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 4 }}>
          3. Disclosure of Data
        </Typography>
        <Typography paragraph>
          We may share your information with trusted third parties who assist us in operating our website, conducting our business, or serving our users, so long as those parties agree to keep this information confidential. We may also release your information when we believe release is appropriate to comply with the law, enforce our site policies, or protect ours or others' rights, property or safety.
        </Typography>

        <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 4 }}>
          4. Security of Data
        </Typography>
        <Typography paragraph>
          The security of your data is important to us, but remember that no method of transmission over the Internet, or method of electronic storage is 100% secure. While we strive to use commercially acceptable means to protect your Personal Data, we cannot guarantee its absolute security.
        </Typography>

        <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 4 }}>
          5. Your Data Protection Rights
        </Typography>
        <Typography paragraph>
          Depending on your location, you may have the following data protection rights:
        </Typography>
        <List dense>
          <ListItem>
            <ListItemText primary="The right to access, update or to delete the information we have on you."
            />
          </ListItem>
          <ListItem>
            <ListItemText primary="The right to rectification."
            />
          </ListItem>
          <ListItem>
            <ListItemText primary="The right to object."
            />
          </ListItem>
          <ListItem>
            <ListItemText primary="The right of restriction."
            />
          </ListItem>
          <ListItem>
            <ListItemText primary="The right to data portability."
            />
          </ListItem>
          <ListItem>
            <ListItemText primary="The right to withdraw consent."
            />
          </ListItem>
        </List>
        <Typography paragraph>
          If you wish to be informed what Personal Data we hold about you and if you want it to be removed from our systems, please contact us.
        </Typography>

        <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 4 }}>
          6. Changes to This Privacy Policy
        </Typography>
        <Typography paragraph>
          We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page. You are advised to review this Privacy Policy periodically for any changes. Changes to this Privacy Policy are effective when they are posted on this page.
        </Typography>

        <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 4 }}>
          7. Contact Us
        </Typography>
        <Typography paragraph>
          If you have any questions about this Privacy Policy, please contact us:
        </Typography>
        <List dense>
          <ListItem>
            <ListItemText primary="By email: solidclassesjodhpur@gmail.com"
            />
          </ListItem>
          <ListItem>
            <ListItemText primary="By phone number: +91 90790-35708"
            />
          </ListItem>
        </List>
      </Paper>
    </Container>
  );
};

export default PrivacyPolicy; 
